module.exports = __webpack_public_path__ + "static/media/outline-sound-icon.ee49fe2a.svg";